import {
  type CreateFolderType,
  type StoreFolder,
  type UpdateFolderType,
} from '@/services/types/mockStoreFolders'
import { api } from './api'
import { endpoints } from './endpoints'

export interface MoveLocationsToFolderProps {
  locationIds: string[]
  folderId: string | null
}

export const storeFoldersService = {
  async getFolders() {
    return await api.get<StoreFolder[]>(endpoints.storeFolders)
  },

  async createFolder(folder: CreateFolderType) {
    return await api.post<CreateFolderType>(endpoints.storeFolders, folder)
  },

  async updateFolder(folderId: string, folder: UpdateFolderType) {
    return await api.patch<UpdateFolderType>(`${endpoints.storeFolders}/${folderId}`, folder)
  },

  async deleteFolder(folderId: string) {
    return await api.delete(`${endpoints.storeFolders}/${folderId}`)
  },

  async moveLocationsToFolder(data: MoveLocationsToFolderProps) {
    return await api.post<string>(`${endpoints.storeFolders}/move`, data)
  },
}
